module.exports = __webpack_public_path__ + "media/images/new_marketing/orange_button-4837b4ab4a76c39e67aa76990b364ecf82ae4c6a09dd20f7d4176970855a47f8.png";